export default __webpack_public_path__ + "static/media/i130vp.ea7a7c9b.webp";